import defaultTheme from './defaultTheme';
const chevronTheme = Object.assign(Object.assign({}, defaultTheme), { link: '#0170c1', button: Object.assign(Object.assign({}, defaultTheme.button), { text: '#0170c1', background: '#0170c1' }), chatIcon: Object.assign(Object.assign({}, defaultTheme.chatIcon), { background: '#0170c1' }), radio: Object.assign(Object.assign({}, defaultTheme.radio), { inactiveBorder: '#0170c1', border: '#0170c1', background: '#0170c1' }), field: {
        focus: '#0170c1',
        label: '#0170c1',
        icon: '#0170c1',
    } });
export default chevronTheme;
